/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileCopy16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M7.663 4c.12 0 .234.045.318.124l2.887 2.714a.41.41 0 01.132.299v6.594c0 .7-.605 1.269-1.35 1.269h-6.3C2.604 15 2 14.432 2 13.73V5.27C2 4.567 2.604 4 3.35 4h4.313zm3-3c.12 0 .234.045.318.124l2.887 2.714a.41.41 0 01.132.299v6.594c0 .7-.605 1.269-1.35 1.269h-.651L12 7.148c0-.396-.165-.772-.453-1.043l-2.867-2.7A1.495 1.495 0 007.655 3H5v-.73C5 1.567 5.604 1 6.35 1h4.313z"
        />
    </AccessibleSVG>
);

export default FileCopy16;
